import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  Status: {
    activationState: null,
  },
};
const NachMode = createSlice({
  name: "Nach",
  initialState: initialState,
  reducers: {
    updateActivationState(state, action) {
      state.Status.activationState = action.payload;
    },
  },
});
export const NachModeAction = NachMode.actions;
export default NachMode.reducer;
